/**
 * RFC-150: Per-page crosslink targets. Mirrors the graph documented in §4 of
 * the RFC. Every page receives ≥ 2 inbound links across the rest of the site.
 *
 * Format: source page key → list of {to, eyebrow, title} cards.
 */
import type { CrosslinkItem } from '@/components/marketing/MarketingCrosslinks';

export type MarketingPageKey =
  | 'landing'
  | 'features'
  | 'how-to-use'
  | 'compare'
  | 'pricing'
  | 'about'
  | 'download'
  | 'schools';

export const MARKETING_CROSSLINKS: Record<MarketingPageKey, CrosslinkItem[]> = {
  landing: [
    { to: '/features',  eyebrow: 'Features',   title: 'See every study mode and tool' },
    { to: '/how-to-use', eyebrow: 'How to use', title: 'A 4-step guide to remembering more' },
    { to: '/pricing',   eyebrow: 'Pricing',    title: 'Free forever, Premium when you need it' },
    { to: '/about',     eyebrow: 'About',      title: 'Why we built Leka' },
  ],
  features: [
    { to: '/how-to-use', eyebrow: 'How to use', title: 'See the workflow in action' },
    { to: '/compare',    eyebrow: 'Compare',    title: 'How Leka stacks up vs Anki' },
    { to: '/pricing',    eyebrow: 'Pricing',    title: 'Pick the plan that fits' },
  ],
  'how-to-use': [
    { to: '/features', eyebrow: 'Features', title: 'Every tool you can use along the way' },
    { to: '/download', eyebrow: 'Download', title: 'Get Leka on iOS and Android' },
    { to: '/schools',  eyebrow: 'Schools',  title: 'Teachers: bring this to your classroom' },
  ],
  compare: [
    { to: '/features', eyebrow: 'Features', title: 'The full feature list' },
    { to: '/pricing',  eyebrow: 'Pricing',  title: 'See what Premium unlocks' },
    { to: '/about',    eyebrow: 'About',    title: 'Why we built Leka the way we did' },
  ],
  pricing: [
    { to: '/features', eyebrow: 'Features', title: 'See what each tier includes' },
    { to: '/compare',  eyebrow: 'Compare',  title: 'Leka vs the alternatives' },
    { to: '/schools',  eyebrow: 'Schools',  title: 'Free Premium for pilot teachers' },
    { to: '/download', eyebrow: 'Download', title: 'Get the apps' },
  ],
  about: [
    { to: '/features', eyebrow: 'Features', title: 'What we built' },
    { to: '/schools',  eyebrow: 'Schools',  title: 'Bringing Leka to classrooms' },
  ],
  download: [
    { to: '/how-to-use', eyebrow: 'How to use', title: 'A 4-step guide to your first 100 words' },
    { to: '/features',   eyebrow: 'Features',   title: 'Tour every study mode' },
  ],
  schools: [
    { to: '/pricing',    eyebrow: 'Pricing',    title: 'Pricing for individual learners' },
    { to: '/about',      eyebrow: 'About',      title: 'Our learning philosophy' },
    { to: '/how-to-use', eyebrow: 'How to use', title: 'See the student workflow' },
  ],
};
